import { useMutation } from '@tanstack/react-query';

import { removeUser } from '../../../../api';

export const useDeleteUser = () =>
  useMutation({ mutationKey: ['removeUser'], mutationFn: (id: number) => removeUser(id) });
